export default "__VITE_ASSET__BIfrO8wY__"